import React, { useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";
import {
  PlusCircleIcon,
  PencilIcon,
  TrashIcon,
  ChevronLeftIcon,
} from "@primer/octicons-react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import ListGroup from "react-bootstrap/ListGroup";
import ListGroupItem from "react-bootstrap/ListGroupItem";
import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Swal from "sweetalert2";

import { BASENAME, REST_API } from "../../../../services/constants";
import { seo } from "../../../../components/seo.component";
import authHeader from "../../../../services/auth-header";
import MarkdownDisplay from "../../../../components/markdown/markdown-display.component";
import { goBackInHistory } from "../../../../services/constants";

export default function AdminDashboardShowTopicPage(props) {
  let { id } = useParams();
  const [topics, setTopics] = useState([]);
  const [accessDenied, setAccessDenied] = useState(false);

  const [topic, setTopic] = useState(null);
  const [topicTasks, setTopicTasks] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);

  const updateTopics = async () => {
    axios({
      url: REST_API + "/api/secure/topics/",
      method: "GET",
      headers: await authHeader(),
    })
      .then((response) => {
        setTopics(response.data);
        setAccessDenied(false);
      })
      .catch((error) => {
        if (error.response) {
          setAccessDenied(error.response.status === 403);
        } else {
          Swal.fire({
            icon: "error",
            title: "Verbindung fehlgeschlagen",
            text: "Es konnte keine Verbindung zum Server hergestellt werden.",
          });
        }
      });
  };

  useEffect(() => {
    updateTopics();
  }, []);

  const updateDetails = async () => {
    axios({
      method: "GET",
      url: REST_API + "/api/secure/topics/" + id,
      headers: await authHeader(),
    }).then((response) => {
      if (response.status === 200) {
        setTopic(response.data);

        seo({
          title: " Admin » " + response.data?.title,
        });
      }
    });
  };

  const updateTasks = async () => {
    axios({
      method: "GET",
      url: REST_API + "/api/secure/tasks/topic/" + id,
      headers: await authHeader(),
    }).then((response) => {
      if (response.status === 200) {
        const sortedTopicTasks = [...response.data].sort((a, b) =>
          a.name.localeCompare(b.name),
        );
        setTopicTasks(sortedTopicTasks);
      }
    });
  };

  const updateAssignedUsers = async () => {
    axios({
      method: "GET",
      url: REST_API + "/api/secure/topics/" + id + "/assigned/",
      headers: await authHeader(),
    }).then((response) => {
      if (response.status === 200) {
        setAssignedUsers(response.data);
      }
    });
  };
  const applyChangesToBackend = async () => {
    console.log("HelloW OWlr");
    axios({
      method: "PATCH",
      url: REST_API + "/api/secure/topics/" + id,
      headers: await authHeader(),
      data: {
        id: id,
        title: topic.title,
        info: topic.info,
        mandatory: topic.mandatory,
        order_nr: topic.order_nr,
      },
    }).then((response) => {
      if (response.status === 200) {
        updateDetails();
      }
    });
  };

  const toggleMandatoryStatus = () => {
    topic.mandatory = !topic.mandatory;
    applyChangesToBackend();
  };

  const showTitleChangeModal = () => {
    Swal.fire({
      icon: "info",
      title: "Titel ändern",
      input: "text",
      inputLabel: "Neuer Name",
      inputValue: topic.title,
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Der Name darf nicht leer sein!";
        }
        if (value === topic.title) {
          return "Der Name darf nicht identisch sein";
        }
      },
    }).then((x) => {
      if (x.isConfirmed) {
        topic.title = x.value;
        applyChangesToBackend();
      }
    });
  };

  const showInfoChangeModal = () => {
    Swal.fire({
      icon: "info",
      title: "Info ändern",
      input: "textarea",
      html:
        'Ändere die Beschreibung. Erwähne Installationsschritte und Voraussetzungen.<br/><a href="' +
        "#" +
        BASENAME +
        'support/cheatsheets/flavoured_markdown/" target="_blank" rel="noreferrer">Markdown Cheatsheet</a>',
      inputPlaceholder: "Markdown Inhalt",
      inputValue: topic.info,
      showCancelButton: true,
    }).then((x) => {
      if (x.isConfirmed) {
        topic.info = x.value;
        applyChangesToBackend();
      }
    });
  };

  const showChangeOrderNrModal = () => {
    Swal.fire({
      icon: "info",
      title: "Position in Reihenfolge ändern",
      input: "number",
      inputPlaceholder: "Pos.",
      inputValue: topic.order_nr,
      showCancelButton: true,
      preConfirm: (newOrderNr) => {
        if (isOrderNrAlreadyTaken(Number(newOrderNr))) {
          Swal.showValidationMessage(
            "Diese Position ist bereits vergeben. Bitte wähle eine andere.",
          );
          return false;
        }
        return newOrderNr;
      },
    }).then((x) => {
      if (x.isConfirmed) {
        topic.order_nr = Number(x.value);
        applyChangesToBackend();
      }
    });
  };

  const isOrderNrAlreadyTaken = (orderNr) => {
    return topics.some((topic) => topic.order_nr === orderNr);
  };

  const showCreateTaskModal = () => {
    Swal.fire({
      icon: "info",
      title: "Neue Aufgabe erstellen",
      input: "text",
      inputValidator: (value) => {
        if (!value) {
          return "Der Name darf nicht leer sein";
        }
      },
    }).then(async (x) => {
      if (x.isConfirmed) {
        axios({
          method: "POST",
          url: REST_API + "/api/secure/tasks/",
          headers: await authHeader(),
          data: {
            id: 0,
            expectsCodeSubmission: false,
            name: x.value,
            content: "",
            topicId: id,
          },
        }).then((response) => {
          if (response.status === 200) {
            updateTasks();
          } else {
            Swal.fire({
              icon: `error`,
              title: `Unbekannter Fehler: ${response.status}`,
              text: `Es ist ein unbekannter Fehler aufgetreten: ${response.statusText}`,
            });
          }
        });
      }
    });
  };

  const showDeleteTaskModal = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Aufgabe löschen?",
      text: "Dies kann nicht rückgängig gemacht werden",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
    }).then(async (x) => {
      if (x.isConfirmed) {
        axios({
          method: "DELETE",
          url: REST_API + "/api/secure/tasks/" + id,
          headers: await authHeader(),
        }).then((response) => {
          if (response.status == 200) {
            Swal.fire({
              icon: "success",
              title: "Aufgabe gelöscht",
              timer: 1500,
            });

            updateTasks();
          }
        });
      }
    });
  };

  const removeUserFromTopic = (userId, name) => {
    Swal.fire({
      icon: "warning",
      title: name + " entfernen?",
      text:
        "Alle Abgaben & Relationen zu diesem Benutzer werden gelöscht. Dies kann nicht rückgängig gemacht werden.",
      showConfirmButton: true,
      confirmButtonColor: "#dc3545",
      showCancelButton: true,
      confirmButtonText: "Ja, Benutzer entfernen",
    }).then(async (x) => {
      if (x.isConfirmed) {
        axios({
          method: "DELETE",
          url: REST_API + "/api/secure/topics/" + id + "/assigned/",
          headers: await authHeader(),
          data: {
            userId: userId,
            topicId: id,
          },
        }).then((response) => {
          if (response.status == 200) {
            Swal.fire({
              icon: "success",
              title: "Erfolgreich entfernt",
              timer: 3000,
            });

            updateAssignedUsers();
          }
        });
      }
    });
  };

  const openAssignUserModal = async () => {
    axios({
      method: "GET",
      url: REST_API + "/api/secure/users/",
      headers: await authHeader(),
    }).then((response) => {
      if (response.status == 200) {
        var userDict = {};

        response.data
          .filter(
            (unfilteredItem) =>
              !assignedUsers.some(
                (someItem) => someItem.id === unfilteredItem.id,
              ),
          )
          .map((item, index) => {
            userDict[item.id] =
              (item.email || item.username) +
              " (" +
              item.firstName +
              " " +
              item.lastName +
              ")";
          });

        Swal.fire({
          icon: "info",
          title: "Benutzer hinzufügen",
          input: "select",
          inputOptions: userDict,
          confirmButtonText: "Benutzer hinzufügen",
          confirmButtonColor: "#28a745",
          showCancelButton: true,
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (!value) {
                resolve("Bitte wähle einen Benutzer");
              } else {
                resolve();
              }
            });
          },
        }).then(async (x) => {
          if (x.isConfirmed && x.value) {
            axios({
              method: "POST",
              url: REST_API + "/api/secure/topics/" + id + "/assigned/",
              headers: await authHeader(),
              data: {
                userId: x.value,
                topicId: id,
              },
            }).then((response2) => {
              if (response2.status == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Benutzer hinzugefügt",
                  timer: 3000,
                });

                updateAssignedUsers();
              }
            });
          }
        });
      }
    });
  };

  const openAssignAllUsersModal = () => {
    Swal.fire({
      icon: "info",
      title: "Alle hinzufügen?",
      text: "Möchtest du wirklich alle Benutzer hinzufügen?",
      confirmButtonText: "Ja, alle hinzufügen",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (x) => {
      if (x.isConfirmed) {
        axios({
          method: "POST",
          url: REST_API + "/api/secure/topics/" + id + "/assigned/all/",
          headers: await authHeader(),
        }).then((response) => {
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: response.data + " Benutzer hinzugefügt",
              timer: 1500,
              showCancelButton: false,
            });

            updateAssignedUsers();
          }
        });
      }
    });
  };

  const openAssignUserByRoleModal = async () => {
    axios({
      method: "GET",
      url: `${REST_API}/api/secure/groups/`,
      headers: await authHeader(),
    })
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            title: "Gruppe hinzufügen",
            html: `
                    <label for='role'>Gruppe</label>
                    <select id='role' class='swal2-input'>
                        ${response.data
                          .map(
                            (entry) =>
                              `<option value="${entry.id}">${entry.name}</option>`,
                          )
                          .join("")}
                    </select>
                    <br/>
                    <input type='checkbox' id='invert' class='swal2-checkbox'>
                    <label for='invert'>Invertieren</label>
                `,
            showCancelButton: true,
            confirmButtonText: "Hinzufügen",
            preConfirm: () => {
              return {
                role: document.getElementById("role").value,
                invert: document.getElementById("invert").checked,
              };
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              axios({
                method: "POST",
                url: `${REST_API}/api/secure/topics/${id}/assigned/all/`,
                headers: await authHeader(),
                params: {
                  role: result.value.role,
                  invert: result.value.invert,
                },
              }).then((response) => {
                if (response.status === 200) {
                  Swal.fire({
                    icon: "success",
                    title: `${response.data} Benutzer hinzugefügt`,
                    timer: 1500,
                    showCancelButton: false,
                  });

                  updateAssignedUsers();
                }
              });
            }
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Unbekannter Fehler",
          text: `Es ist ein unbekannter Fehler aufgetreten. ${
            err.response ? `Error Code: ${err.response.status}` : "Time out"
          }`,
        });
      });
  };

  const openRemoveAllUsersModal = () => {
    Swal.fire({
      icon: "warning",
      title: "Alle Benutzer entfernen?",
      text:
        "Alle Benutzer werden Entfernt. Antworten zu den Aufgaben werden gelöscht. Fortfahren?",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      confirmButtonText: "Ja, alle Benutzer entfernen",
    }).then(async (x) => {
      if (x.isConfirmed) {
        axios({
          method: "DELETE",
          url: REST_API + "/api/secure/topics/" + id + "/assigned/all/",
          headers: await authHeader(),
        }).then((response) => {
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Alle Benutzer entfernt",
              timer: 3000,
            });

            updateAssignedUsers();
          }
        });
      }
    });
  };

  const showTaskQuickEditModal = (task) => {
    Swal.fire({
      title: `Quick Edit #${task.id}`,
      html: `
            <label for='task_title'>Aufgaben Titel</label>
            <input id='task_title' class='swal2-input' type='text' value='${task.name}' required>
            <br/>
            <label for='task_content'>Aufgaben Inhalt</label>
            <textarea id='task_content' class='swal2-textarea'>${task.content}</textarea>
            <label>Alle dazugehörigen Files werden nicht gelöscht. </label>
        `,
      showCancelButton: true,
      confirmButtonText: "Speichern",
      preConfirm: () => {
        return {
          task_title: document.getElementById("task_title").value,
          task_content: document.getElementById("task_content").value,
        };
      },
    }).then(async (result) => {
      console.log("Executing Request DAWDWADAD");
      console.log("Topic ID: " + task.topicId);
      if (result.isConfirmed) {
        axios({
          method: "PATCH",
          url: REST_API + "/api/secure/tasks/",
          headers: await authHeader(),
          data: {
            id: task.id,
            name: result.value.task_title,
            content: result.value.task_content,
            expectsCodeSubmission: task.expectsCodeSubmission,
            topicId: task.topicId,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              Swal.fire({
                icon: "success",
                title: "Änderungen gespeichert",
                timer: 1000,
                showConfirmButton: false,
              });

              updateTasks();
            }
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Änderungen nicht gespeichert",
              timer: 3000,
              showConfirmButton: false,
            });
          });
      }
    });
  };

  const [multiEditTaskList, setMultiEditTaskList] = useState([]);

  const deleteAllTasksFromMultiEdit = () => {
    const expectedSucessfulDeletions = multiEditTaskList.length;
    var actualSuccessfullDeletions = 0;

    multiEditTaskList.map(async (entry) => {
      axios({
        method: "DELETE",
        url: REST_API + "/api/secure/tasks/" + entry,
        headers: await authHeader(),
      }).then((response) => {
        if (response && response.status === 200) {
          actualSuccessfullDeletions++;

          if (actualSuccessfullDeletions === expectedSucessfulDeletions) {
            Swal.fire({
              icon: "success",
              title: `Erfolgreich ${actualSuccessfullDeletions} Aufgaben gelöscht`,
              timer: 3000,
              showConfirmButton: false,
            });

            updateTasks();
          }
        }
      });
    });
  };

  const showMultiEditDeleteTasks = () => {
    Swal.fire({
      icon: "warning",
      title: "Löschung bestätigen",
      html: `Achtung: Du bist dabei, ${multiEditTaskList.length} Aufgaben zu löschen.`,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAllTasksFromMultiEdit();
        setMultiEditTaskList([]);
      }
    });
  };

  const toggleMultiEditForTask = (id) => {
    if (multiEditTaskList.includes(id)) {
      setMultiEditTaskList(multiEditTaskList.filter((x) => x !== id));
    } else {
      setMultiEditTaskList([...multiEditTaskList, id]);
    }
  };

  useEffect(() => {
    updateDetails();
    updateTasks();
    updateAssignedUsers();
  }, []);

  return (
    <>
      <Row>
        <Col sm={12} md={6} lg={6}>
          <Card className="mb-4">
            <Card.Header>
              <Button
                onClick={() => goBackInHistory(props)}
                className="mr-4 py-2"
              >
                <ChevronLeftIcon />
                Zurück
              </Button>
              Eigenschaften
            </Card.Header>
            <ListGroup className="list-group-flush">
              <ListGroupItem>
                <div className="row">
                  <div className="col">
                    <b>Titel</b>
                    <br />
                    <p>{topic ? topic.title : "Laden..."}</p>
                  </div>
                  <div className="col-md-auto align-self-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => showTitleChangeModal()}
                    >
                      <PencilIcon size={16} className="mr-2" />
                      Ändern
                    </button>
                  </div>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <div className="row">
                  <div className="col">
                    <b>Allgemeine Informationen</b>
                    <br />
                    {topic ? (
                      <MarkdownDisplay content={topic?.info} />
                    ) : (
                      "Laden..."
                    )}
                  </div>
                  <div className="col-md-auto align-self-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => showInfoChangeModal()}
                    >
                      <PencilIcon size={16} className="mr-2" />
                      Ändern
                    </button>
                  </div>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <b>Einstellungen</b>
                <br />

                {topic ? (
                  <Form.Check
                    type="checkbox"
                    className="my-1 mr-sm-2 ml-3 custom-checkbox-inline"
                    label="Obligatorisch"
                    id="current_topic_settings_mandatory"
                    custom
                    checked={topic.mandatory}
                    onChange={() => toggleMandatoryStatus()}
                  />
                ) : (
                  <span>Laden...</span>
                )}
              </ListGroupItem>
              <ListGroupItem>
                <div className="row">
                  <div className="col">
                    <b>Position in Reihenfolge</b>
                    <br />
                    <p>{topic ? topic.order_nr : "Laden..."}</p>
                  </div>
                  <div className="col-md-auto align-self-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => showChangeOrderNrModal()}
                    >
                      <PencilIcon size={16} className="mr-2" />
                      Ändern
                    </button>
                  </div>
                </div>
              </ListGroupItem>
            </ListGroup>
          </Card>

          <Card className="mb-4">
            <Card.Header>Teilnehmer</Card.Header>
            <Card.Body>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Benutzer</th>
                    <th>Erledigte Aufgaben</th>
                    <th>Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {!assignedUsers || assignedUsers.length === 0 ? (
                    <tr>
                      <td colSpan={4}>
                        <span className="text-muted">Keine Daten</span>
                      </td>
                    </tr>
                  ) : (
                    assignedUsers.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.id}</td>
                          <td>
                            <Link to={"/admin-dashboard/accounts/" + item.id}>
                              {item.email || item.username}
                            </Link>
                          </td>
                          <td>?</td>
                          <td>
                            <Button
                              className="mb-2"
                              variant="danger"
                              onClick={() =>
                                removeUserFromTopic(item.id, item.username)
                              }
                            >
                              <TrashIcon size={16} className="mr-2" />
                              Entfernen
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </Card.Body>
            <Card.Footer>
              <Button
                className="mr-2 mb-2"
                onClick={() => openAssignAllUsersModal()}
              >
                <PlusCircleIcon size={16} className="mr-2" />
                Alle hinzufügen
              </Button>
              <Button
                className="mr-2 mb-2"
                onClick={() => openAssignUserByRoleModal()}
              >
                <PlusCircleIcon size={16} className="mr-2" />
                Alle von Gruppe hinzufügen
              </Button>
              <Button
                className="mr-2 mb-2"
                onClick={() => openAssignUserModal()}
              >
                <PlusCircleIcon size={16} className="mr-2" />
                Hinzufügen
              </Button>
              <Button
                variant="danger"
                className="mb-2"
                onClick={() => openRemoveAllUsersModal()}
              >
                <TrashIcon size={16} className="mr-2" />
                Alle entfernen
              </Button>
            </Card.Footer>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6}>
          <Card>
            <Card.Header>Aufgaben</Card.Header>
            <Card.Body>
              {multiEditTaskList != null && multiEditTaskList.length > 0 ? (
                <Card className="mb-4">
                  <Card.Body>
                    <Card.Title>
                      Multi Edit ({multiEditTaskList.length} ausgewählt)
                    </Card.Title>
                    <Button
                      variant="danger"
                      onClick={() => showMultiEditDeleteTasks()}
                    >
                      Delete
                    </Button>
                  </Card.Body>
                </Card>
              ) : (
                <></>
              )}

              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Titel</th>
                    <th>Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {topicTasks.length === 0 ? (
                    <tr>
                      <td colSpan="3">
                        <span className="text-muted">Keine Daten</span>
                      </td>
                    </tr>
                  ) : (
                    topicTasks.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <Form.Check
                              id={`checkbox-tasks-multi-edit-${index}`}
                              type="checkbox"
                              checked={multiEditTaskList.includes(item.id)}
                              custom
                              onChange={() => toggleMultiEditForTask(item.id)}
                              label={item.id}
                            />
                          </td>
                          <td>{item.name}</td>
                          <td>
                            <Button
                              className="mr-2 mb-2"
                              href={
                                "#" +
                                BASENAME +
                                "admin-dashboard/topics/" +
                                id +
                                "/tasks/" +
                                item.id
                              }
                            >
                              Bearbeiten
                            </Button>
                            <Button
                              className="mr-2 mb-2"
                              onClick={() => showTaskQuickEditModal(item)}
                            >
                              Quick-Edit
                            </Button>
                            <Button
                              className="mb-2"
                              variant="danger"
                              onClick={() => showDeleteTaskModal(item.id)}
                            >
                              <TrashIcon size={16} className="mr-2" />
                              Löschen
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </Card.Body>
            <Card.Footer>
              <Button onClick={() => showCreateTaskModal()}>
                <PlusCircleIcon size={16} className="mr-2" />
                Neu
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </>
  );
}
